import * as angular from 'angular';
import { Features } from '../../../../../../../../../frontend/libs/shared/src/lib/types/features';

class AptAssessmentLiteComponentCtrl {
  /*
    popoverContainer expects a string example popover-container="'body'"
  */
  static bindings = {
    featureList: '<',
    assessmentData: '<',
    popoverContainer: '@',
    voteOnClick: '&',
    addNoteOnClick: '&',
    productId: '<',
    productCrossApproveCount: '=',
    productCrossDisputeCount: '=',
    sizeVersion: '@',
    notesTitle: '@',
    thumbsUpTitle: '@',
    thumbsDownTitle: '@',
    hasThumbsButtonPopover: '<',
  };

  featureList: Features;
  assessmentData;
  popoverContainer;
  activeTab: string;
  voteOnClick;
  addNoteOnClick;
  newNote: string;
  productId: number;
  productCrossApproveCount;
  productCrossDisputeCount;
  sizeVersion: string;
  notesTitle: string;
  thumbsUpTitle: string;
  thumbsDownTitle: string;
  hasThumbsButtonPopover: boolean;
  isLiteVersion = true; // This is necessary because popover template is used by both lite and full assessment component versions.

  constructor(private $scope, private $animate, private $element) {
    'ngInject';
  }

  getCrossProductId(product) {
    return product.productId ? product.productId : product.id;
  }

  updateVote(vote, $event) {
    $event.stopPropagation();
    if (this.assessmentData) {
      this.voteOnClick({
        productId: this.productId,
        crossReferenceId: this.assessmentData.crossReferenceId,
        opinionType: this.assessmentData.crossOpinion,
        vote: vote,
        toProductId: this.getCrossProductId(this.assessmentData),
      });
      this.runAnimation();
    }
  }

  // Patch up because uses same popover template as full assessment component.
  updateVoteAndNote = this.addNote;

  addNote(selectedOption = null, note: string) {
    if (this.assessmentData) {
      this.addNoteOnClick({
        productId: this.productId,
        crossReferenceId: this.assessmentData.crossReferenceId,
        note: note,
        toProductId: this.getCrossProductId(this.assessmentData),
      });

      this.newNote = '';
      this.activeTab = 'notes';
    }
  }

  isThereComments() {
    if (this.assessmentData) {
      if (this.assessmentData.notes) {
        return this.assessmentData.notes.length > 0;
      }
    }
  }

  setActiveTab() {
    if (this.assessmentData) {
      if (this.assessmentData.notes.length > 0) {
        return (this.activeTab = 'notes');
      } else {
        return (this.activeTab = 'add');
      }
    }
  }

  runAnimation() {
    if (
      angular
        .element(this.$element[0].querySelector('.assessment-comment-button'))
        .hasClass('scaleUp')
    ) {
      this.$animate
        .removeClass(
          this.$element[0].querySelector('.assessment-comment-button'),
          'scaleUp',
        )
        .then(() => {
          this.$animate.addClass(
            this.$element[0].querySelector('.assessment-comment-button'),
            'scaleUp',
          );
        });
    } else {
      this.$animate.addClass(
        this.$element[0].querySelector('.assessment-comment-button'),
        'scaleUp',
      );
    }
  }

  isThereAContainer() {
    if (this.popoverContainer) {
      return this.popoverContainer;
    } else {
      return 'body';
    }
  }

  setSizeVersion() {
    if (this.sizeVersion) {
      let output = '';
      let sizeVersion = this.sizeVersion.toLowerCase();

      switch (sizeVersion) {
        case 'small':
          output = 'btn-xs';
          return output;
        case 'medium':
          output = 'btn-md';
          return output;
        case 'large':
          output = 'btn-lg';
          return output;
        default:
          return output;
      }
    }
  }
}

export const AptAssessmentLiteComponent = {
  template: require('./aptAssessmentLite.component.html'),
  controller: AptAssessmentLiteComponentCtrl,
  transclude: true,
  bindings: AptAssessmentLiteComponentCtrl.bindings,
};
